import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getDatiIban(iban,apiPath) {
    return (dispatch) => {
        API.getAxios(apiPath).get(`/anagrafica/iban/${iban}/controllo`)
        .then(response => { 
            dispatch({ type: actionTypes.SALVA_DATI_IBAN, payload: response.data})
        })
        .catch(errore => {
            dispatch({ type: actionTypes.SALVA_DATI_IBAN, payload: errore.response.data});
        })
    };
}

export default getDatiIban;